import React from "react";
import Box from "@mui/material/Box";
import HeaderBar from "../HeaderBar/HeaderBar";
import {
  gridContainerStyle,
  fullWidthGridStyle,
  homePaceComponentStyle,
  paperBoxStyle,
} from "../../utils/constants";
import { Grid } from "@mui/material";
import PageFooter from "../PageFooter/PageFooter";

/**
 * No breadcrumbs here since EB-555, and none anywhere else in the app.
 *
 * What used to sit under the header rendered no trail: it listed every `NAV_ITEMS` entry collapsed
 * to `maxItems={2}`, so every page — storefront and admin alike — said "Página Principal / … /
 * Juegos", and none of them said where the visitor was. Half the storefront had already opted out
 * with a `hideBreadcrumbs` prop, which is the clearest evidence it was never carrying its weight.
 * The prop went with it.
 */
interface Props {
  children: React.ReactNode;
  fullWidth?: boolean;
  /**
   * Defaults to `true`: the storefront outnumbers the admin, and a missing search on a shop page
   * is a worse failure than a stray one over an admin grid. Admin routes pass `false`.
   */
  showSearch?: boolean;
}

export const PageLayout: React.FC<Props> = ({ children, fullWidth, showSearch = true }) => {
  return (
    <Box sx={homePaceComponentStyle}>
      <Grid container direction="column" sx={fullWidth ? fullWidthGridStyle : gridContainerStyle}>
        <Box sx={paperBoxStyle}>
          <HeaderBar showSearch={showSearch} />
          {children}
        </Box>
        <PageFooter />
      </Grid>
    </Box>
  );
};
